// extracted by css-extract-rspack-plugin
export default {"root":"root-bIoo1X","nested":"nested-Wy2rx6"};